export default {"src":"/_next/static/media/video.f5ff0dce.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};